export const GET_DAYENTRIES = "GET_DAYENTRIES";
export const GET_TECHNICIANS = "GET_TECHNICIANS";
export const GET_DUTYROSTER = "GET_DUTYROSTER";
export const GET_TECHNICIAN_DROP = "GET_TECHNICIAN_DROP";
export const GET_ALL_RECORDS_TECHNICIAN = "GET_ALL_RECORDS_TECHNICIAN";
export const GET_ALL_RECORDS_TECHNICIAN_SHIFTS = "GET_ALL_RECORDS_TECHNICIAN_SHIFTS";
export const SET_ROSTER_DATE_RANGE = "SET_ROSTER_DATE_RANGE";
export const SET_ROSTER_LOADING = "SET_ROSTER_LOADING";
export const SET_ROSTER_WEEK = "SET_ROSTER_WEEK";
